<div class="container">
  <div class="row mt-2">
    <div class="col-md-12">
      <h1 class="mt-4 ms-4"><em>@if (message !== '') {
        <span>{{message}}</span>
      }</em></h1>
    </div>
  </div>
</div>
<div class="container">
  <div class="d-flex flex-row justify-content-start align-items-center" [ngClass]="{ 'flex-wrap': isMobile }">
    <div class="tile-box">
      <a href="/engagements/shellFilter" title="">
        <img src="/assets/tiles/imanage-shell-filterlist.png" />
      </a>
    </div>
    @if (showTeamsLink) {
      <div class="tile-box">
        <a href="{{teamsUrl}}" title="Microsoft Teams" target="_blank">
          <img src="/assets/tiles/imanage-ms-teams.png" />
        </a>
      </div>
    }
    <div class="tile-box">
      <a href="{{accountsUrl}}" title="" target="_blank">
        <img src="/assets/tiles/imanage-accounts.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{opportunitiesUrl}}" title="" target="_blank">
        <img src="/assets/tiles/imanage-opportunities.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{pmToolboxUrl}}" title="" target="_blank">
        <img src="/assets/tiles/imanage-pm-toolbox.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{proConnectUrl}}" title="" target="_blank">
        <img src="/assets/tiles/imanage-pro-connect.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{iShareUrl}}" title="" target="_blank">
        <img src="/assets/iShare_Tile.png" />
      </a>
    </div>
  </div>
  <div class="d-flex flex-row justify-content-start align-items-center mb-5" [ngClass]="{ 'flex-wrap': isMobile }">
    <div class="tile-box">
      <a href="{{budgetsUrl}}" title="">
        <img src="/assets/tiles/imanage-budgets.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{winStrategyUrl}}" title="Win Strategy" target="_blank">
        <img src="/assets/tiles/imanage-win-strategy.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{ERAUrl}}" title=""><img src="/assets/tiles/imanage-era.png" /></a>
    </div>
    <div class="tile-box">
      <a href="{{hubUrl}}" title="" target="_blank"><img src="/assets/tiles/imanage-the-hub.png"></a>
    </div>
    <div class="tile-box">
      <a href="{{pkicUrl}}" title="" target="_blank">
        <img src="/assets/tiles/pkic-portal.png" />
      </a>
    </div>
    <div class="tile-box">
      <a href="{{peopleUrl}}" title="" target="_blank">
        <img src="/assets/tiles/imanage-people-search.png" />
      </a>
    </div>
    @if (displayIAccessTile) {
      <div class="tile-box">
        <a href="{{iAccessURL}}" title="" target="_blank">
          <img src="/assets/iAccess_Tile.png" />
        </a>
      </div>
    }
  </div>
</div>